// Lib
import { createSelector } from 'reselect';

// Utils
import { isEmpty, propIn } from '../../../../../common/utils/immutableHelper';
import { createDeepSelector } from '../../../../utils/milanoteReselect/milanoteReselect';
import { filterAndSortAssignmentSuggestions } from '../../../mentions/filterAndSortSuggestions';

// Selectors
import { getUserMentionSuggestions } from '../../../mentions/mentionsSelector';
import { getElement } from '../../../selectors/elementSelector';
import { getAssignments } from '../../../../../common/elements/utils/elementPropertyUtils';

export const selectCurrentlyAssignedUserId = createSelector(getElement, (element) => {
    const assignments = getAssignments(element);

    return isEmpty(assignments) ? null : propIn([0, 'assigneeId'], assignments);
});

export const selectFilteredSuggestions = createDeepSelector(
    (state: any, { searchTerm }: { searchTerm: string }) => searchTerm,
    selectCurrentlyAssignedUserId,
    getUserMentionSuggestions,
    filterAndSortAssignmentSuggestions,
);
